import Vue from 'vue'
import axios from 'axios'
//import Axios from './config/client';
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/css/tailwind.css'

Vue.use(VueAxios, axios)
Vue.use(VueMeta)

Vue.axios.defaults.baseURL = process.env.VUE_APP_API;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
